import { debounce } from 'ts-debounce';
import { SearchService } from './SearchService';

export class KeywordInput<TFacets extends string, ISearchResult> {
	protected _element: JQuery<HTMLElement>;
	protected _searchService: SearchService<TFacets, ISearchResult>;
	protected _input: JQuery<HTMLElement>;
	protected _clearButton: JQuery<HTMLElement>;

	/**
	 *
	 * @param element
	 * @param searchService
	 */
	constructor(
		element: JQuery<HTMLElement>,
		searchService: SearchService<TFacets, ISearchResult>,
	) {
		this._element = element;
		this._searchService = searchService;
		this._input = $('input', element);
		this._clearButton = $('button', element);

		const debouncedChange = debounce(() => {
			this.handleChange();
		}, 100);

		this._input.on('keyup', () => {
			this.handleClearButtonDisplay();
			debouncedChange();
		});

		this._clearButton.on('click', () => {
			this._input.val('').trigger('keyup');
		});

		this.handleClearButtonDisplay();
	}

	protected handleClearButtonDisplay() {
		if (this._input.val()) {
			this._clearButton.show();
		} else {
			this._clearButton.hide();
		}
	}

	protected handleChange() {
		const newSearchParams = this._searchService.searchParams;

		if (this._input.val() && this._input.val().toString().length >= 2) {
			newSearchParams.textSearch = this._input.val().toString();
		} else {
			newSearchParams.textSearch = '';
		}
		this._searchService.searchParams = newSearchParams;
	}
}



// WEBPACK FOOTER //
// ./scripts/algolia/KeywordInput.ts